import AdminLayout from "@/pages/admin/components/AdminLayout.vue";

export default [
  {
    name: "adminLogin",
    path: "/login",
    meta: { title: "RainChat 后台管理系统", guestOnly: true },
    component: () => import("@/pages/admin/login.vue"),
  },
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAdmin: true },
    redirect: { name: "bdManagement" },
    children: [
      {
        name: "bdManagement",
        path: "bd",
        meta: { title: "BD 管理", requiresAdmin: true, roles: ["BDM"] },
        component: () => import("@/pages/admin/bdManagement.vue"),
      },
      {
        name: "guildManagement",
        path: "guild",
        meta: { title: "公会管理", requiresAdmin: true, roles: ["BDM", "BD"] },
        component: () => import("@/pages/admin/guildManagement.vue"),
      },
      {
        name: "anchorManagement",
        path: "anchor-management",
        meta: { title: "主播管理", requiresAdmin: true, roles: ["公会长"] },
        component: () => import("@/pages/admin/anchorManagement.vue"),
      },
      {
        name: "anchorData",
        path: "anchor-data",
        meta: { title: "主播数据", requiresAdmin: true, roles: ["BDM", "BD"] },
        component: () => import("@/pages/admin/anchorData.vue"),
      },
    ],
  },
];
